export const translations = {
  sr: {
    nav: {
      home: 'Početna',
      products: 'Naši Proizvodi',
      about: 'O Nama',
      contact: 'Kontakt',
      admin: 'Admin Panel'
    },
    hero: {
      title: 'Prirodni Med sa Marković Gazdinstva',
      subtitle: 'Organski med iz netaknute prirode, sa padina planina i livada širom Srbije',
      cta: 'Pogledajte Naše Proizvode',
      learnMore: 'Saznajte Više'
    },
    about: {
      title: 'O Nama',
      description: 'Mi smo porodično Gazdinstvo Marković. Godinama se bavimo proizvodnjom organskog meda iz netaknute prirode sa padina planina i livada širom Srbije.',
      subtitle: 'Naša Misija',
      mission: 'Da proizvedemo najkvalitetniji prirodni med, uz poštovanje pčela i prirode',
      pageTitle: 'O Gazdinstvu Marković',
      hero: {
        title: 'O Nama',
        subtitle: 'Porodična tradicija pčelarstva i ljubav prema prirodi'
      },
      story: {
        title: 'Naša Priča',
        intro: 'U srcu netaknutih predela Srbije, gde divlje cveće njiše na laganom povetarcu i simfonija zujanja pčela ispunjava vazduh, leži utočište prirodnog pčelarstva. Ovde, usred netaknutih livada i bujnih šuma, pčelari praktikuju svoj zanat u skladu sa prirodom, negujući simbiotski odnos između pčela i njihove sredine.',
        content1: 'Gazdinstvo Marković je porodično pčelarsko gazdinstvo sa dugom tradicijom proizvodnje organskog meda. Naša priča započela je pre više decenija, kada je naš osnivač prvi put postavio košnice u netaknutoj prirodi srpskih planina.',
        content2: 'Danas, sa ponosom nastavljamo porodičnu tradiciju, pridržavajući se istih vrednosti kvaliteta, poštovanja prema prirodi i ljubavi prema pčelarstvu koje su nas vodile od samog početka.',
        content3: 'Naše pčele sakupljaju nektar sa čistih livada i šuma, daleko od urbanog zagađenja i industrijskih zona. To našem medu daje jedinstvenu čistoću i bogat ukus koji odražava prirodnu raznolikost srpske flore.'
      },
      values: {
        title: 'Naše Vrednosti',
        quality: {
          title: 'Kvalitet',
          desc: 'Samo najbolji med stiže do naših kupaca. Svaka serija se pažljivo testira.'
        },
        tradition: {
          title: 'Tradicija',
          desc: 'Koristimo tradicionalne metode pčelarstva prenete kroz generacije.'
        },
        nature: {
          title: 'Priroda',
          desc: 'Poštujemo prirodu i naše pčele, održavajući ravnotežu ekosistema.'
        },
        family: {
          title: 'Porodica',
          desc: 'Porodično gazdinstvo gde svaki član doprinosi proizvodnji kvalitetnog meda.'
        }
      },
      process: {
        title: 'Naš Proces',
        step1: {
          title: 'Odabir Lokacije',
          desc: 'Pažljivo biramo netaknute lokacije sa bogatom florom daleko od zagađenja'
        },
        step2: {
          title: 'Nega Pčela',
          desc: 'Naše pčele dobijaju najbolju negu i prirodno okruženje za razvoj'
        },
        step3: {
          title: 'Berba Meda',
          desc: 'Med beremo u pravom trenutku kada je potpuno zreo'
        },
        step4: {
          title: 'Kontrola Kvaliteta',
          desc: 'Svaka serija prolazi stroge testove kvaliteta u laboratoriji'
        }
      },
      commitment: {
        title: 'Naša Posvećenost',
        text: 'Posvećeni smo proizvodnji najkvalitetnijeg organskog meda uz potpuno poštovanje prirode i naših pčela. Svaka teglica našeg meda nosi sa sobom ljubav prema prirodi i tradiciju pčelarstva.'
      }
    },
    features: {
      title: 'Zašto Odabrati Naš Med',
      quality: {
        title: '100% Prirodan',
        description: 'Naš med je potpuno prirodan, bez dodataka i konzervansa'
      },
      organic: {
        title: 'Organska Proizvodnja',
        description: 'Pčele sakupljaju nektar sa organskih livada daleko od zagađenja'
      },
      traditional: {
        title: 'Tradicionalni Metodi',
        description: 'Koristimo tradicionalne metode pčelarstva koje se prenose generacijama'
      },
      tested: {
        title: 'Laboratorijski Testiran',
        description: 'Svaka serija meda se testira kako bi se garantovao kvalitet'
      }
    },
    products: {
      title: 'Naši Proizvodi',
      subtitle: 'Istražite našu ponudu čistog, organskog meda iz srca Srbije',
      viewAll: 'Pogledajte Sve Proizvode',
      learnMore: 'Saznajte Više',
      noProducts: 'Trenutno nema dostupnih proizvoda.',
      meadowHoney: 'Livadski Med',
      meadowDesc: 'Čist med od divljeg cveća sa planinskih livada',
      acaciaHoney: 'Bagremov Med',
      acaciaDesc: 'Svetao i nežan med od cveta bagrema',
      forestHoney: 'Šumski Med',
      forestDesc: 'Bogat tamni med od nektara šumskog drveća',
      whyChoose: 'Zašto Odabrati Naš Med?',
      natural: '100% Prirodan',
      naturalDesc: 'Bez dodataka, konzervansa ili veštačkih sastojaka',
      organic: 'Organska Proizvodnja',
      organicDesc: 'Iz netaknutih livada i šuma',
      family: 'Porodično Gazdinstvo',
      familyDesc: 'Tradicionalni metodi pčelarstva koji se prenose kroz generacije',
      tested: 'Kvalitet Testiran',
      testedDesc: 'Svaka serija je laboratorijski testirana na čistoću'
    },
    cta: {
      title: 'Iskusite Čist Ukus Prirode',
      description: 'Kontaktirajte nas da saznate više o našim proizvodima od meda i naručite'
    },
    contact: {
      title: 'Kontaktirajte Nas',
      subtitle: 'Imate pitanja? Rado ćemo vam pomoći!',
      form: {
        name: 'Vaše Ime',
        email: 'Email Adresa',
        message: 'Vaša Poruka',
        submit: 'Pošaljite Poruku',
        success: 'Poruka uspešno poslata!',
        error: 'Greška pri slanju poruke. Pokušajte ponovo.'
      },
      confirmation: {
        title: 'Hvala vam!',
        message: 'Uspešno smo primili vašu poruku i zahvaljujemo se na interesovanju za naše gazdinstvo i proizvode.',
        details: 'Trenutno razmatramo vaš upit i javićemo vam se u najkraćem mogućem roku.',
        urgent: 'Ukoliko je vaš upit hitan, molimo vas kontaktirajte nas na navedeni telefon.',
        email: 'Email potvrda je poslata na vašu email adresu.',
        backButton: 'Nazad na početnu'
      },
      info: {
        title: 'Informacije',
        address: 'Adresa',
        email: 'Email',
        phone: 'Telefon',
        hours: 'Radno Vreme',
        monday: 'Pon – Pet',
        mondayTime: '9h-22h',
        weekend: 'Subota i Nedelja',
        weekendTime: '8h-20h'
      }
    },
    footer: {
      about: 'Mi smo porodično Gazdinstvo Marković. Godinama se bavimo proizvodnjom organskog meda iz netaknute prirode sa padina planina i livada širom Srbije.',
      poweredBy: 'Sa ponosom pokreće'
    },
    admin: {
      title: 'Admin Panel',
      login: {
        title: 'Prijavite se',
        username: 'Korisničko ime',
        password: 'Lozinka',
        submit: 'Prijavite se',
        error: 'Pogrešno korisničko ime ili lozinka',
        demoCredentials: 'Demo Podaci za Prijavu',
        demoUsername: 'Korisničko ime',
        demoPassword: 'Lozinka'
      },
      logout: 'Odjavite se',
      products: {
        title: 'Upravljanje Proizvodima',
        add: 'Dodaj Novi Proizvod',
        edit: 'Uredi',
        delete: 'Obriši',
        save: 'Sačuvaj',
        cancel: 'Otkaži',
        name: 'Naziv Proizvoda',
        description: 'Opis',
        price: 'Cena',
        image: 'URL Slike',
        uploadImage: 'Otpremi Sliku',
        imageUploaded: 'Slika uspešno optimizovana!',
        optimizingImage: 'Optimizacija slike...',
        imageTooLarge: 'Slika je prevelika. Maksimalna veličina je 5MB.',
        invalidImageType: 'Nevažeći format slike. Molimo izaberite sliku.',
        deleteConfirm: 'Da li ste sigurni da želite da obrišete ovaj proizvod?',
        deleteTitle: 'Potvrda Brisanja',
        serbian: 'Srpski',
        english: 'Engleski',
        russian: 'Ruski',
        requiredFields: 'Molimo popunite sva obavezna polja',
        addSuccess: 'Proizvod uspešno dodat!',
        updateSuccess: 'Proizvod uspešno ažuriran!',
        deleteSuccess: 'Proizvod uspešno obrisan!',
        loginSuccess: 'Uspešno ste se prijavili!',
        logoutSuccess: 'Uspešno ste se odjavili!'
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      products: 'Our Products',
      about: 'About Us',
      contact: 'Contact',
      admin: 'Admin Panel'
    },
    hero: {
      title: 'Natural Honey from Markovic Family Farm',
      subtitle: 'Organic honey from untouched nature on the slopes of mountains and meadows throughout Serbia',
      cta: 'View Our Products',
      learnMore: 'Learn More'
    },
    about: {
      title: 'About Us',
      description: 'We are the Marković family farm. For years, we have been engaged in the production of organic honey from untouched nature on the slopes of mountains and meadows throughout Serbia.',
      subtitle: 'Our Mission',
      mission: 'To produce the highest quality natural honey while respecting bees and nature',
      pageTitle: 'About Marković Family Farm',
      hero: {
        title: 'About Us',
        subtitle: 'Family beekeeping tradition and love for nature'
      },
      story: {
        title: 'Our Story',
        intro: 'In the heart of Serbia\'s pristine, untouched landscapes, where wildflowers sway in the gentle breeze and the symphony of buzzing bees fills the air, lies a sanctuary of natural beekeeping. Here, amidst untouched meadows and lush forests, beekeepers practice their craft in harmony with nature, fostering a symbiotic relationship between bees and their environment.',
        content1: 'Marković Family Farm is a family beekeeping farm with a long tradition of producing organic honey. Our story began decades ago when our founder first placed beehives in the untouched nature of Serbian mountains.',
        content2: 'Today, we proudly continue the family tradition, adhering to the same values of quality, respect for nature, and love for beekeeping that have guided us from the very beginning.',
        content3: 'Our bees collect nectar from pristine meadows and forests, far from urban pollution and industrial zones. This gives our honey a unique purity and rich taste that reflects the natural diversity of Serbian flora.'
      },
      values: {
        title: 'Our Values',
        quality: {
          title: 'Quality',
          desc: 'Only the best honey reaches our customers. Every batch is carefully tested.'
        },
        tradition: {
          title: 'Tradition',
          desc: 'We use traditional beekeeping methods passed down through generations.'
        },
        nature: {
          title: 'Nature',
          desc: 'We respect nature and our bees, maintaining ecosystem balance.'
        },
        family: {
          title: 'Family',
          desc: 'A family farm where every member contributes to quality honey production.'
        }
      },
      process: {
        title: 'Our Process',
        step1: {
          title: 'Location Selection',
          desc: 'We carefully choose pristine locations with rich flora far from pollution'
        },
        step2: {
          title: 'Bee Care',
          desc: 'Our bees receive the best care and natural environment for development'
        },
        step3: {
          title: 'Honey Harvest',
          desc: 'We harvest honey at the right moment when it is fully mature'
        },
        step4: {
          title: 'Quality Control',
          desc: 'Every batch undergoes strict laboratory quality tests'
        }
      },
      commitment: {
        title: 'Our Commitment',
        text: 'We are committed to producing the highest quality organic honey with complete respect for nature and our bees. Each jar of our honey carries with it a love for nature and the tradition of beekeeping.'
      }
    },
    features: {
      title: 'Why Choose Our Honey',
      quality: {
        title: '100% Natural',
        description: 'Our honey is completely natural, without additives or preservatives'
      },
      organic: {
        title: 'Organic Production',
        description: 'Bees collect nectar from organic meadows far from pollution'
      },
      traditional: {
        title: 'Traditional Methods',
        description: 'We use traditional beekeeping methods passed down through generations'
      },
      tested: {
        title: 'Laboratory Tested',
        description: 'Each batch of honey is tested to guarantee quality'
      }
    },
    products: {
      title: 'Our Products',
      subtitle: 'Explore our selection of pure, organic honey products from the heart of Serbia',
      viewAll: 'View All Products',
      learnMore: 'Learn More',
      noProducts: 'No products available at the moment.',
      meadowHoney: 'Meadow Honey',
      meadowDesc: 'Pure wildflower honey from mountain meadows',
      acaciaHoney: 'Acacia Honey',
      acaciaDesc: 'Light and delicate honey from acacia blossoms',
      forestHoney: 'Forest Honey',
      forestDesc: 'Rich dark honey from forest tree nectar',
      whyChoose: 'Why Choose Our Honey?',
      natural: '100% Natural',
      naturalDesc: 'No additives, preservatives, or artificial ingredients',
      organic: 'Organic Production',
      organicDesc: 'From untouched meadows and forests',
      family: 'Family Farm',
      familyDesc: 'Traditional beekeeping methods passed down through generations',
      tested: 'Quality Tested',
      testedDesc: 'Every batch is laboratory tested for purity'
    },
    cta: {
      title: 'Experience the Pure Taste of Nature',
      description: 'Get in touch with us to learn more about our honey products and place your order'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Have questions? We\'re here to help!',
      form: {
        name: 'Your Name',
        email: 'Email Address',
        message: 'Your Message',
        submit: 'Send Message',
        success: 'Message sent successfully!',
        error: 'Error sending message. Please try again.'
      },
      confirmation: {
        title: 'Thank You!',
        message: 'We have successfully received your message and appreciate your interest in our farm and products.',
        details: 'We will review your request and get back to you as soon as possible.',
        urgent: 'If your inquiry is urgent, please contact us at the phone number provided.',
        email: 'A confirmation email has been sent to your email address.',
        backButton: 'Back to Home'
      },
      info: {
        title: 'Information',
        address: 'Address',
        email: 'Email',
        phone: 'Phone',
        hours: 'Working Hours',
        monday: 'Mon – Fri',
        mondayTime: '9AM-10PM',
        weekend: 'Saturday and Sunday',
        weekendTime: '8AM-8PM'
      }
    },
    footer: {
      about: 'We are the Marković family farm. For years, we have been engaged in the production of organic honey from untouched nature on the slopes of mountains and meadows throughout Serbia.',
      poweredBy: 'Proudly Powered By'
    },
    admin: {
      title: 'Admin Panel',
      login: {
        title: 'Login',
        username: 'Username',
        password: 'Password',
        submit: 'Login',
        error: 'Invalid username or password',
        demoCredentials: 'Demo Credentials',
        demoUsername: 'Username',
        demoPassword: 'Password'
      },
      logout: 'Logout',
      products: {
        title: 'Product Management',
        add: 'Add New Product',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        name: 'Product Name',
        description: 'Description',
        price: 'Price',
        image: 'Image URL',
        uploadImage: 'Upload Image',
        imageUploaded: 'Image optimized successfully!',
        optimizingImage: 'Optimizing image...',
        imageTooLarge: 'Image is too large. Maximum size is 5MB.',
        invalidImageType: 'Invalid image format. Please select an image.',
        deleteConfirm: 'Are you sure you want to delete this product?',
        deleteTitle: 'Confirm Deletion',
        serbian: 'Serbian',
        english: 'English',
        russian: 'Russian',
        requiredFields: 'Please fill in all required fields',
        addSuccess: 'Product added successfully!',
        updateSuccess: 'Product updated successfully!',
        deleteSuccess: 'Product deleted successfully!',
        loginSuccess: 'Successfully logged in!',
        logoutSuccess: 'Successfully logged out!'
      }
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      products: 'Наши Продукты',
      about: 'О Нас',
      contact: 'Контакты',
      admin: 'Панель Администратора'
    },
    hero: {
      title: 'Натуральный Мед с Семейной Фермы Маркович',
      subtitle: 'Органический мед из нетронутой природы со склонов гор и лугов по всей Сербии',
      cta: 'Посмотреть Наши Продукты',
      learnMore: 'Узнать Больше'
    },
    about: {
      title: 'О Нас',
      description: 'Мы - семейная ферма Маркович. Уже много лет мы занимаемся производством органического меда из нетронутой природы со склонов гор и лугов по всей Сербии.',
      subtitle: 'Наша Миссия',
      mission: 'Производить натуральный мед высочайшего качества, уважая пчел и природу',
      pageTitle: 'О Семейной Ферме Маркович',
      hero: {
        title: 'О Нас',
        subtitle: 'Семейная традиция пчеловодства и любовь к природе'
      },
      story: {
        title: 'Наша История',
        intro: 'В сердце нетронутых ландшафтов Сербии, где полевые цветы качаются на легком ветерке и симфония жужжания пчел наполняет воздух, находится святилище естественного пчеловодства. Здесь, среди нетронутых лугов и пышных лесов, пчеловоды практикуют своё ремесло в гармонии с природой, способствуя симбиотическим отношениям между пчелами и их средой обитания.',
        content1: 'Семейная ферма Маркович - это семейная пасека с долгой традицией производства органического меда. Наша история началась несколько десятилетий назад, когда наш основатель впервые разместил ульи в нетронутой природе сербских гор.',
        content2: 'Сегодня мы с гордостью продолжаем семейную традицию, придерживаясь тех же ценностей качества, уважения к природе и любви к пчеловодству, которые направляли нас с самого начала.',
        content3: 'Наши пчелы собирают нектар с чистых лугов и лесов, вдали от городского загрязнения и промышленных зон. Это придает нашему меду уникальную чистоту и богатый вкус, отражающий природное разнообразие сербской флоры.'
      },
      values: {
        title: 'Наши Ценности',
        quality: {
          title: 'Качество',
          desc: 'Только лучший мед попадает к нашим клиентам. Каждая партия тщательно тестируется.'
        },
        tradition: {
          title: 'Традиция',
          desc: 'Мы используем традиционные методы пчеловодства, передающиеся из поколения в поколение.'
        },
        nature: {
          title: 'Природа',
          desc: 'Мы уважаем природу и наших пчел, поддерживая баланс экосистемы.'
        },
        family: {
          title: 'Семья',
          desc: 'Семейная ферма, где каждый член вносит вклад в производство качественного меда.'
        }
      },
      process: {
        title: 'Наш Процесс',
        step1: {
          title: 'Выбор Локации',
          desc: 'Мы тщательно выбираем нетронутые места с богатой флорой вдали от загрязнения'
        },
        step2: {
          title: 'Уход за Пчелами',
          desc: 'Наши пчелы получают лучший уход и естественную среду для развития'
        },
        step3: {
          title: 'Сбор Меда',
          desc: 'Мы собираем мед в нужный момент, когда он полностью созрел'
        },
        step4: {
          title: 'Контроль Качества',
          desc: 'Каждая партия проходит строгие лабораторные испытания качества'
        }
      },
      commitment: {
        title: 'Наши Обязательства',
        text: 'Мы привержены производству органического меда высочайшего качества с полным уважением к природе и нашим пчелам. Каждая баночка нашего меда несет в себе любовь к природе и традицию пчеловодства.'
      }
    },
    features: {
      title: 'Почему Стоит Выбрать Наш Мед',
      quality: {
        title: '100% Натуральный',
        description: 'Наш мед полностью натуральный, без добавок и консервантов'
      },
      organic: {
        title: 'Органическое Производство',
        description: 'Пчелы собирают нектар с органических лугов вдали от загрязнений'
      },
      traditional: {
        title: 'Традиционные Методы',
        description: 'Мы используем традиционные методы пчеловодства, передающиеся из поколения в поколение'
      },
      tested: {
        title: 'Лабораторно Протестирован',
        description: 'Каждая партия меда тестируется для гарантии качества'
      }
    },
    products: {
      title: 'Наши Продукты',
      subtitle: 'Исследуйте наш выбор чистого, органического меда из сердца Сербии',
      viewAll: 'Посмотреть Все Продукты',
      learnMore: 'Узнать Больше',
      noProducts: 'В настоящее время нет доступных продуктов.',
      meadowHoney: 'Луговой Мед',
      meadowDesc: 'Чистый мед из диких цветов с горных лугов',
      acaciaHoney: 'Акациевый Мед',
      acaciaDesc: 'Светлый и нежный мед из цветов акации',
      forestHoney: 'Лесной Мед',
      forestDesc: 'Богатый темный мед из нектара лесных деревьев',
      whyChoose: 'Почему Стоит Выбрать Наш Мед?',
      natural: '100% Натуральный',
      naturalDesc: 'Без добавок, консервантов или искусственных ингредиентов',
      organic: 'Органическое Производство',
      organicDesc: 'Из нетронутых лугов и лесов',
      family: 'Семейная Ферма',
      familyDesc: 'Традиционные методы пчеловодства, передающиеся из поколения в поколение',
      tested: 'Качество Проверено',
      testedDesc: 'Каждая партия проходит лабораторные испытания на чистоту'
    },
    cta: {
      title: 'Испытайте Чистый Вкус Природы',
      description: 'Свяжитесь с нами, чтобы узнать больше о наших продуктах из меда и сделать заказ'
    },
    contact: {
      title: 'Свяжитесь с Нами',
      subtitle: 'Есть вопросы? Мы здесь, чтобы помочь!',
      form: {
        name: 'Ваше Имя',
        email: 'Email Адрес',
        message: 'Ваше Сообщение',
        submit: 'Отправить Сообщение',
        success: 'Сообщение успешно отправлено!',
        error: 'Ошибка отправки сообщения. Попробуйте снова.'
      },
      confirmation: {
        title: 'Спасибо!',
        message: 'Мы успешно получили ваше сообщение и ценим ваш интерес к нашей ферме и продуктам.',
        details: 'Мы рассмотрим ваш запрос и свяжемся с вами как можно скорее.',
        urgent: 'Если ваш запрос срочный, пожалуйста, свяжитесь с нами по указанному телефону.',
        email: 'Подтверждение отправлено на ваш электронный адрес.',
        backButton: 'Вернуться на главную'
      },
      info: {
        title: 'Информация',
        address: 'Адрес',
        email: 'Email',
        phone: 'Телефон',
        hours: 'Часы Работы',
        monday: 'Пон – Пят',
        mondayTime: '9:00-22:00',
        weekend: 'Суббота и Воскресенье',
        weekendTime: '8:00-20:00'
      }
    },
    footer: {
      about: 'Мы - семейная ферма Маркович. Уже много лет мы занимаемся производством органического меда из нетронутой природы со склонов гор и лугов по всей Сербии.',
      poweredBy: 'С гордостью разработано'
    },
    admin: {
      title: 'Панель Администратора',
      login: {
        title: 'Вход',
        username: 'Имя пользователя',
        password: 'Пароль',
        submit: 'Войти',
        error: 'Неверное имя пользователя или пароль',
        demoCredentials: 'Демо Данные для Входа',
        demoUsername: 'Имя пользователя',
        demoPassword: 'Пароль'
      },
      logout: 'Выйти',
      products: {
        title: 'Управление Продуктами',
        add: 'Добавить Новый Продукт',
        edit: 'Редактировать',
        delete: 'Удалить',
        save: 'Сохранить',
        cancel: 'Отмена',
        name: 'Название Продукта',
        description: 'Описание',
        price: 'Цена',
        image: 'URL Изображения',
        uploadImage: 'Загрузить Изображение',
        imageUploaded: 'Изображение успешно оптимизировано!',
        optimizingImage: 'Оптимизация изображения...',
        imageTooLarge: 'Изображение слишком большое. Максимальный размер 5MB.',
        invalidImageType: 'Неверный формат изображения. Пожалуйста, выберите изображение.',
        deleteConfirm: 'Вы уверены, что хотите удалить этот продукт?',
        deleteTitle: 'Подтвердить Удаление',
        serbian: 'Сербский',
        english: 'Английский',
        russian: 'Русский',
        requiredFields: 'Пожалуйста, заполните все обязательные поля',
        addSuccess: 'Продукт успешно добавлен!',
        updateSuccess: 'Продукт успешно обновлен!',
        deleteSuccess: 'Продукт успешно удален!',
        loginSuccess: 'Вы успешно вошли!',
        logoutSuccess: 'Вы успешно вышли!'
      }
    }
  }
};